<template>
  <div class="section section-basic">
    <div class="container">
      <h2 class="text-left title">Trip Planner Benefit</h2>
      <div class="row">
        <div class="col-md-4">
          <img src="ilustrator/destination.png" alt="" class="float-left image-destination">
        </div>
        <div class="col-md-8">
          <h1>1.</h1>
          <p class="h3">Research bot that works for you</p>
          <p>Matches your travel preferences with over 230,000,000 data points:</p>
          <ul>
            <li>Best places & time to visit</li>
            <li>Reviews</li>
            <li>Transportation options</li>
            <li>Hidden gems</li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col-md-8">
          <h1 class="title-2">2.</h1>
          <p class="h3">Planning engine that helps you see & do more</p>
          <ul>
            <li>Optimizes your itinerary</li>
            <li>Minimizes travel time</li>
          </ul>
        </div>
        <div class="col-md-4">
          <img src="ilustrator/travelers.png" alt="" class="float-right image-traveler">
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <img src="ilustrator/booking.png" alt="" class="float-left image-booking">
        </div>
        <div class="col-md-8">
          <h1>3.</h1>
          <p class="h3">Your complete trip in one place</p>
          <ul>
            <li>Share and collaborate with co-travelers</li>
            <li>Say hi to your new travel hub!</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>